import { utils, writeFile } from 'xlsx';

export function downloadCSV(data: any[], filename: string) {
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => 
      headers.map(header => {
        const value = row[header]?.toString() ?? '';
        // Escape quotes and wrap in quotes if contains comma or quote
        return value.includes(',') || value.includes('"') 
          ? `"${value.replace(/"/g, '""')}"` 
          : value;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadExcel(data: any[], filename: string) {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Quotes');
  writeFile(workbook, `${filename}.xlsx`);
}

export function formatQuoteForExport(quote: any) {
  return {
    'Quote ID': quote.id,
    'User ID': quote.user_id,
    'Quote': quote.text,
    'Author': quote.author,
    'Age': quote.age || '',
    'Location': quote.location || '',
    'Context': quote.context || '',
    'Year': quote.year || '',
    'Favorite': quote.isFavorite ? 'TRUE' : 'FALSE',
    'Quotewall': quote.quotewall ? 'TRUE' : 'FALSE',
    'Created At': quote.created_at || '',
    'Updated At': quote.updated_at || ''
  };
}